import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

export function useShareResources(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `mutation shareProcesses($recipientEmails: [String]!, $processesId: [ID]!) {
                    shareProcesses(recipientEmails: $recipientEmails, processesId: $processesId) {
                        successMessage
                    }
                   }`;

    const resolver = (response) => {
      return { data: response.data.shareProcesses };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const [shareProcessesMutation, { loading }] = useMutationWithToaster(
    mutationFactory,
    { onDone }
  );

  return {
    isLoading: loading,
    shareProcesses: async ({ emails, processes }) => {
      return shareProcessesMutation(
        {
          recipientEmails: emails,
          processesId: Object.entries(processes)
            .filter(([, value]) => {
              return value;
            })
            .map(([key]) => {
              return key;
            }),
        },
        {
          successMsg: "Successfully shared resources",
          defaultErrorMsg:
            "Failed to share resources. Please retry or contact support for assistance.",
        }
      );
    },
  };
}

export default useShareResources;
